import produce from "immer";
import { ADD_TO_PIN_LIST, DEL_ITEM_PIN_LIST, SET_PIN_LIST } from "../actions/pin.list.action";

const initialState = {
    pinList: []
}

const pinListReducer = produce((state, action) => {
    switch(action.type) {
        case SET_PIN_LIST:
            return {
                pinList: action.newList
            }
        case ADD_TO_PIN_LIST:
            return {
                pinList: [...state.pinList, action.newItem]
            }
        case DEL_ITEM_PIN_LIST:
            const result = Array.from(state.pinList)
            result.splice(result.indexOf(result.filter((item) => item == action.item)[0]), 1)
            return {
                pinList: result
            }
        default:
            console.warn('Invalid Action');
            break
    }
}, initialState)

export default pinListReducer